// javascript
import './style.scss';

document.addEventListener('DOMContentLoaded', function () {
    if (window.innerWidth <= 768) {
        return;
    }

    const animatedContainers = document.querySelectorAll('.animated');

    animatedContainers.forEach(section => {
        const brandsContainer = section.querySelector('.our-clients__brands');

        if (brandsContainer && !brandsContainer.classList.contains('marquee-container')) {
            const DEFAULT_COPIES = 10;
            const MAX_COPIES = 200;
            const attrCopies = parseInt(brandsContainer.dataset.iterations, 10);
            const copies = Number.isFinite(attrCopies)
                ? Math.min(Math.max(attrCopies, 10), MAX_COPIES)
                : DEFAULT_COPIES;

            const DEFAULT_SPEED = 100;
            const speedAttr = parseFloat(brandsContainer.dataset.speed);
            const speed = Number.isFinite(speedAttr) && speedAttr > 0 ? speedAttr : DEFAULT_SPEED;

            const originalChildren = Array.from(brandsContainer.children);
            if (originalChildren.length === 0) {
                return;
            }

            // клонируем содержимое
            const fragment = document.createDocumentFragment();
            for (let i = 0; i < copies; i++) {
                originalChildren.forEach(node => fragment.appendChild(node.cloneNode(true)));
            }

            brandsContainer.innerHTML = '';
            brandsContainer.appendChild(fragment);
            brandsContainer.classList.add('marquee-container');

            const imgs = Array.from(brandsContainer.querySelectorAll('img'));
            const imgsLoaded = Promise.all(imgs.map(img => {
                if (img.complete && img.naturalWidth !== 0) return Promise.resolve();
                return new Promise(resolve => {
                    img.addEventListener('load', resolve, { once: true });
                    img.addEventListener('error', resolve, { once: true });
                });
            }));

            imgsLoaded.then(() => {
                requestAnimationFrame(() => {
                    const fullWidth = brandsContainer.scrollWidth;
                    const singleWidth = fullWidth / copies;
                    const durationSec = singleWidth / speed;

                    brandsContainer.style.setProperty('--marquee-duration', `${durationSec}s`);
                    brandsContainer.style.setProperty('--marquee-shift-px', `${singleWidth}px`);
                    brandsContainer.style.whiteSpace = 'nowrap';
                    brandsContainer.style.flexWrap = 'nowrap';
                    brandsContainer.style.willChange = 'transform';
                    brandsContainer.style.transform = `translate3d(-${singleWidth}px, 0, 0)`;

                    const anim = brandsContainer.animate([
                        { transform: `translate3d(-${singleWidth}px, 0, 0)` },
                        { transform: 'translate3d(0, 0, 0)' }
                    ], {
                        duration: Math.max(20, durationSec * 1000),
                        iterations: Infinity,
                        easing: 'linear',
                    });

                    anim.pause();

                    const onEnter = () => {
                        section.classList.add('is-hovered');
                        // play/resume
                        anim.play();
                    };
                    const onLeave = () => {
                        section.classList.remove('is-hovered');
                        anim.pause();
                    };

                    section.addEventListener('mouseenter', onEnter);
                    section.addEventListener('mouseleave', onLeave);
                });
            });
        }
    });
});